import { z } from 'zod'

export default function isValidEmail(email: string) {
  const res = z.string().email().safeParse(email.toLowerCase().trim())

  return res.success
}
